/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DayDetails {
    getFixupPrototypeFunction() { return DayDetails.fixupPrototype; }

    static newInstance(model: Partial<DayDetails>): DayDetails {
        let obj = Object.assign(new DayDetails(), model);
        DayDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DayDetails>): DayDetails {
        if (!model) return null;
        return DayDetails.newInstance(<DayDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DayDetails) {
        if (!obj) return;

        models.DayDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DayDetails): boolean {
        Object.setPrototypeOf(obj, DayDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * At which day of that month the Template/Policy is scheduled to run.Allowed values: 01-31
     */
    day: string;

}
